module.exports = ".collapsible-header {\n  background-color: #0277bd;\n  color: white; }\n\n.collapsible-header:hover {\n  opacity: .8 !important; }\n\n#curso-nome {\n  text-align: center; }\n\n#curso-nome:hover {\n  font-size: .9em;\n  background-color: #26a69a;\n  color: white; }\n\n#parte-curso {\n  display: none; }\n\n.materialize-textarea {\n  margin-bottom: 0px;\n  padding: 0px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cursos/cursos.component.scss
// module id = ./src/app/cursos/cursos.component.scss
// module chunks = main